import { RouterProvider } from "react-router-dom";
import { AppRouter } from "@/routes/AppRouter";

function App() {
  return <RouterProvider router={AppRouter} fallbackElement={<div>Loading</div>} />;
}

export default App;
